import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { generateKey } from '@/utils';
import Placeholder from '@/components/Placeholder';
import Image from '@/components/ContentfulImage';
import {
  RecommendedListWrap,
  ContentsTitle,
  RecommendedItem,
  ItemInfomationWrap,
  ItemImage,
  ItemTitle,
  ItemStatus,
  ItemCaption,
  PowerContainer,
  PowerTitle,
  PowerValueContainer,
} from '@/pages/HairDiagnosis/HairDiagnosisResultPage/SalonMenuResult/SalonMenuResult.style';

class SalonMenuResult extends React.Component {
  renderPower = power => {
    const indents = [];
    for (let i = 0; i < 4; i += 1) {
      if (i < power) {
        indents.push(<li key={generateKey('power-value', i)} className="active" />);
      } else {
        indents.push(<li key={generateKey('power-value', i)} />);
      }
    }
    return indents;
  };

  renderTitle = title => {
    const tits = title.split('、');
    return tits.map((e, i) => (
      <React.Fragment>
        {i === tits.length - 1 ? <div key={generateKey(i)}>{`${e}`}</div> : <div key={generateKey(i)}>{`${e}、`}</div>}
      </React.Fragment>
    ));
  };

  render() {
    const { copy, salonMenuResult } = this.props;

    return (
      <RecommendedListWrap>
        <ContentsTitle>{copy.recommend_title || <Placeholder w="50%%" h="20px" />}</ContentsTitle>
        <RecommendedItem>
          <ItemImage>
            {(!!(salonMenuResult && _.get(salonMenuResult, 'image')) && <Image src={salonMenuResult.image} />) || (
              <Placeholder w="526px" h="350px" />
            )}
          </ItemImage>
          <ItemInfomationWrap>
            <ItemTitle>
              <p className="lead">{copy.salon_solution || <Placeholder w="50%" h="16px" />}</p>
              {(!!(salonMenuResult && _.get(salonMenuResult, 'title')) && (
                <div className="title">{this.renderTitle(salonMenuResult.title)}</div>
              )) || <Placeholder w="300px" h="45px" />}
            </ItemTitle>
            <ItemStatus>
              {!!(salonMenuResult && _.get(salonMenuResult, 'features')) &&
                salonMenuResult.features.map((feature, index) => (
                  <PowerContainer key={generateKey('feature', index)}>
                    {feature.name && <PowerTitle>{feature.name}</PowerTitle>}
                    {feature.value && (
                      <PowerValueContainer>
                        <ul className="powerbar">{this.renderPower(feature.value)}</ul>
                      </PowerValueContainer>
                    )}
                  </PowerContainer>
                ))}
            </ItemStatus>
            <ItemCaption>
              {(!!(salonMenuResult && _.get(salonMenuResult, 'steps')) &&
                salonMenuResult.steps.description && <p>{salonMenuResult.steps.description}</p>) || (
                <Placeholder w="300px" h="300px" />
              )}
            </ItemCaption>
          </ItemInfomationWrap>
        </RecommendedItem>
      </RecommendedListWrap>
    );
  }
}

SalonMenuResult.defaultProps = {
  copy: {},
  salonMenuResult: {},
};

SalonMenuResult.propTypes = {
  copy: PropTypes.shape({}),
  salonMenuResult: PropTypes.shape({}),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyHairDiagnosisSummary,
  locale: state.locale,
});

export default connect(mapState)(SalonMenuResult);



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/SalonMenuResult/index.js